import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { SelectorSimpleFactory } from "app/features/selectores/logic";

type Entity = models.FiltroCliente;

export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void> | void;
}

const Limite = SelectorSimpleFactory([25, 50, 100, 200, 500, 1000, 2000], x => x, x => "" + x);


/**
* Componente para editar un Entity
*/
export class FiltroClienteComponent extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    getField = formfields(() => this.props);

    render() {
        const { value } = this.props;
        const getField = this.getField;

        const Text = getField(kea.Text);
        const TipoPersona = getField(selectores.TipoPersona);
        const SiNo = getField(selectores.SiNo);
        const Lim = getField(Limite);

        return (
            <div>
                {kea.autogrid(3, [
                    <Text field="Nombre" label="Nombre:" />,
                    <TipoPersona field="TipoPersona" label="Tipo Persona:" />,
                    <Text field="Ine" label="INE:" />,
                    <Text field="Rfc" label="RFC:" />,
                    <Text field="Curp" label="CURP:" />,
                    <Text field="Pasaporte" label="Pasaporte:" />,
                    <Lim field="Limite" label="Límite:" />,
                    <SiNo field="EsDeCredito" label="¿Es de crédito?" />
                ])}
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/list/filtro.tsx